import axios from 'axios'
import gmCrypt from 'gm-crypt'
import md5 from 'js-md5'

const service = axios.create({
	baseURL: process.env.NODE_ENV == 'development' ? '/api' : 'https://svr.szeasycard.com',
	timeout: 30000
})

service.interceptors.response.use(
	response => {
		if (response.data.body !== "") {
			var base64str = hexToBase64(response.data.body)
			var aaa = sm4_(base64str)
			response.data.data = JSON.parse(aaa)
		}
		if (response.data.errorcode == 1004) {
			sessionStorage['_token'] = ""
			sessionStorage['_login'] = 'false'
		}
		return response
	},
	error => {
		console.log(error)
		if (isRequestTimeout(error)) {
			error.userMessage = '请求超时，请稍后重试'
		} else if (error && error.response) {
			error.userMessage = '服务异常，请稍后重试'
		} else if (error && error.message) {
			error.userMessage = '网络异常，请检查网络后重试'
		}
		return Promise.reject(error)
	}
)

function isRequestTimeout(error) {
	if (!error) {
		return false
	}
	if (error.code === 'ECONNABORTED') {
		return true
	}
	const msg = String(error.message || '')
	return msg.toLowerCase().indexOf('timeout') > -1
}

export const getRequestErrorMessage = (error, fallback = '操作失败') => {
	if (error && error.userMessage) {
		return error.userMessage
	}
	if (isRequestTimeout(error)) {
		return '请求超时，请稍后重试'
	}
	return fallback
}

export const get = (url, params) => {
	return service.get(url, {
		params
	})
}

export const post = (url, data) => {
	var model = Sign(url)
	var ciphertext = sm4(JSON.stringify(data))
	model.data = ciphertext
	url = '/' + url + '_api'
	return service.post(url, model)
}

function sm4(str) {
	const pwdKey = "26FB8A700C3462AD"
	const iiv = "788AC4B73435A3F5"
	let gmCryptConfig = {
		key: pwdKey,
		iv: iiv,
		mode: "cbc",
		cipherType: "base64"
	}
	const sm4Util = new gmCrypt.sm4(gmCryptConfig)
	const base64String = sm4Util.encrypt(str)
	const buffer = Buffer.from(base64String, 'base64')
	const HexString = buffer.toString('hex')
	return HexString
}

function sm4_(base64String) {
	const pwdKey = "26FB8A700C3462AD"
	const iiv = "788AC4B73435A3F5"
	let gmCryptConfig = {
		key: pwdKey,
		iv: iiv,
		mode: "cbc",
		cipherType: "base64"
	}
	const sm4Util = new gmCrypt.sm4(gmCryptConfig)
	const decryptedText = sm4Util.decrypt(base64String)
	return decryptedText
}

function Sign(apiCode) {
	const API_SECRET_KEY = "EDB0315900B0F553"
	var RequestContent = {
		token: sessionStorage['_token'],
		timestamp: Math.floor(Date.now() / 1000)
	}
	var temp = API_SECRET_KEY + '_' + apiCode + '_' + RequestContent.timestamp
	RequestContent.sign = md5(temp).toUpperCase()
	return RequestContent
}

function hexToBytes(hex) {
	const bytes = []
	for (let i = 0; i < hex.length; i += 2) {
		bytes.push(parseInt(hex.substr(i, 2), 16))
	}
	return bytes
}

function bytesToBase64(bytes) {
	let binary = ''
	for (let i = 0; i < bytes.length; i++) {
		binary += String.fromCharCode(bytes[i])
	}
	return btoa(binary)
}

function hexToBase64(hex) {
	const bytes = hexToBytes(hex)
	return bytesToBase64(bytes)
}

export default service
